import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';

import SuspenseLoader from 'src/components/SuspenseLoader';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

// Enquiry routes
const CustomerWiseLead = Loader(
  lazy(
    () => import('src/components/lead-management/view-lead/customer-wise-lead')
  )
);
const VendorWiseLead = Loader(
  lazy(
    () => import('src/components/lead-management/view-lead/vendor-wise-lead')
  )
);

const ViewCustomerWiseLeadDetails = Loader(
  lazy(() => import('src/components/lead-management/customer-view/index'))
);

const ViewVendorWiseLeadDetails = Loader(
  lazy(() => import('src/components/lead-management/vendor-view/index'))
);

const PackageWiseLeadDetails = Loader(
  lazy(() => import('src/components/lead-management/package-wise-lead'))
);

const PackageCustomerLeadDetails = Loader(
  lazy(() => import('src/components/lead-management/package-customer-lead'))
);

const enquiryRoutesAdmin = [
  {
    path: '',
    element: <Navigate to="customer-wise-lead" replace />
  },
  {
    path: 'view-lead',
    children: [
      {
        path: 'customer-lead',
        element: <CustomerWiseLead />
      },
      {
        path: 'vendor-lead',
        element: <VendorWiseLead />
      },
      {
        path: 'customer-lead-details',
        element: <ViewCustomerWiseLeadDetails />
      },
      {
        path: 'vendor-lead-details',
        element: <ViewVendorWiseLeadDetails />
      },
      {
        path: 'package-lead-details',
        element: <PackageWiseLeadDetails />
      },
      {
        path: 'customer-details',
        element: <PackageCustomerLeadDetails />
      }
    ]
  }
];

export default enquiryRoutesAdmin;
